import { render, staticRenderFns } from "./pc-item.vue?vue&type=template&id=cfcb3f42"
import script from "./pc-item.vue?vue&type=script&lang=js"
export * from "./pc-item.vue?vue&type=script&lang=js"
import style0 from "./pc-item.vue?vue&type=style&index=0&id=cfcb3f42&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports